// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ProductosRouteImport } from './routes/productos'
import { Route as NosotrosRouteImport } from './routes/nosotros'
import { Route as LegalRouteImport } from './routes/legal'
import { Route as CookiesRouteImport } from './routes/cookies'
import { Route as ContactoRouteImport } from './routes/contacto'
import { Route as BlogRouteImport } from './routes/blog'
import { Route as IndexRouteImport } from './routes/index'

const ProductosRoute = ProductosRouteImport.update({
            id: '/productos',path: '/productos',getParentRoute: () => rootRouteImport
          })
const NosotrosRoute = NosotrosRouteImport.update({
            id: '/nosotros',path: '/nosotros',getParentRoute: () => rootRouteImport
          })
const LegalRoute = LegalRouteImport.update({
            id: '/legal',path: '/legal',getParentRoute: () => rootRouteImport
          })
const CookiesRoute = CookiesRouteImport.update({
            id: '/cookies',path: '/cookies',getParentRoute: () => rootRouteImport
          })
const ContactoRoute = ContactoRouteImport.update({
            id: '/contacto',path: '/contacto',getParentRoute: () => rootRouteImport
          })
const BlogRoute = BlogRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,BlogRoute: BlogRoute,ContactoRoute: ContactoRoute,CookiesRoute: CookiesRoute,LegalRoute: LegalRoute,NosotrosRoute: NosotrosRoute,ProductosRoute: ProductosRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)